<template>
  <div class="page-wrapper">
    <h2 class="tw-mb-6">Einstellungen - Firmendaten</h2>

    <div class="company-wrapper">
      <div class="company-general" v-if="companyInfo">
        <div class="tw-flex tw-flex-col tw-gap-2 md:tw-gap-6">
          <span class="tw-font-bold">Allgemeine Daten</span>

          <div class="tw-flex tw-flex-col tw-font-medium tw-text-sm">
            <span v-if="companyInfo.companyName">{{ companyInfo.companyName }}</span>
            <span v-if="companyInfo.firstName || companyInfo.lastName">{{ companyInfo.firstName }} {{ companyInfo.lastName }}</span>
            <span v-if="companyInfo.address">{{ companyInfo.address }}</span>
            <span v-if="companyInfo.zipCode || companyInfo.city">{{ companyInfo.zipCode }} {{ companyInfo.city }}</span>
            <span v-if="companyInfo.country">{{ companyInfo.country }}</span>
          </div>
        </div>

        <div class="tw-flex tw-flex-col tw-gap-4 md:tw-gap-6" v-if="companyInfo.logo">
          <span class="tw-font-bold">Firmenlogo</span>

          <img
            class="tw-w-full tw-object-contain"
            style="max-width: 200px; max-height: 140px;"
            :src="companyInfo.logo"
            alt="Rechnungsfuchs Logo"
          >
        </div>

        <div class="tw-flex tw-flex-col tw-gap-2 md:tw-gap-6" v-if="companyInfo.email">
          <span class="tw-font-bold">Email</span>

          <div class="tw-flex tw-flex-col tw-font-medium tw-text-sm">
            <span class="tw-truncate">{{ companyInfo.email }}</span>
          </div>
        </div>
      </div>

      <div class="company-block">
        <div class="company-block--top">
          <div class="tw-flex tw-flex-col tw-mb-6">
            <h3 class="tw-font-semibold">Einstellungen - Stammdaten</h3>
            <span class="tw-text-sm tw-text-gray-500">Einstellungen für die Stammdaten Ihrer Firma</span>
          </div>

          <div class="tw-flex tw-flex-col tw-gap-2">
            <span class="tw-text-sm tw-font-medium">Firmenlogo</span>

            <div
              class="tw-w-full tw-h-48 tw-rounded-lg tw-bg-white tw-flex tw-items-center tw-justify-center tw-border tw-border-gray-300 tw-border-dashed tw-cursor-pointer"
              @click="triggerLogoFileInput"
            >
              <div v-if="!imagePreview" class="tw-flex tw-flex-col tw-items-center tw-gap-4">
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M3 12C3 10.8065 3.47411 9.66193 4.31802 8.81802C5.16193 7.97411 6.30653 7.5 7.5 7.5H40.5C41.6935 7.5 42.8381 7.97411 43.682 8.81802C44.5259 9.66193 45 10.8065 45 12V36C45 37.1935 44.5259 38.3381 43.682 39.182C42.8381 40.0259 41.6935 40.5 40.5 40.5H7.5C6.30653 40.5 5.16193 40.0259 4.31802 39.182C3.47411 38.3381 3 37.1935 3 36V12ZM6 32.12V36C6 36.828 6.672 37.5 7.5 37.5H40.5C40.8978 37.5 41.2794 37.342 41.5607 37.0607C41.842 36.7794 42 36.3978 42 36V32.12L36.62 26.742C36.0575 26.1802 35.295 25.8646 34.5 25.8646C33.705 25.8646 32.9425 26.1802 32.38 26.742L30.62 28.5L32.56 30.44C32.7074 30.5773 32.8256 30.7429 32.9076 30.9269C32.9895 31.1109 33.0336 31.3095 33.0372 31.511C33.0407 31.7124 33.0037 31.9124 32.9282 32.0992C32.8528 32.286 32.7405 32.4556 32.5981 32.5981C32.4556 32.7405 32.286 32.8528 32.0992 32.9282C31.9124 33.0037 31.7124 33.0407 31.511 33.0372C31.3095 33.0336 31.1109 32.9895 30.9269 32.9076C30.7429 32.8256 30.5773 32.7074 30.44 32.56L20.12 22.242C19.5575 21.6802 18.795 21.3646 18 21.3646C17.205 21.3646 16.4425 21.6802 15.88 22.242L6 32.122V32.12ZM26.25 16.5C26.25 15.9033 26.4871 15.331 26.909 14.909C27.331 14.4871 27.9033 14.25 28.5 14.25C29.0967 14.25 29.669 14.4871 30.091 14.909C30.5129 15.331 30.75 15.9033 30.75 16.5C30.75 17.0967 30.5129 17.669 30.091 18.091C29.669 18.5129 29.0967 18.75 28.5 18.75C27.9033 18.75 27.331 18.5129 26.909 18.091C26.4871 17.669 26.25 17.0967 26.25 16.5Z" fill="#D1D5DC"/>
                </svg>

                <div class="tw-flex tw-flex-col tw-gap-1 tw-text-center tw-text-gray-500">
                  <span class="tw-text-sm"><span class="text-gradient tw-font-semibold">Datei hochladen</span> oder reinziehen</span>
                  <span class="tw-text-xs">PNG, JPG, bis zu 10MB</span>
                </div>
              </div>

              <input
                type="file"
                ref="fileInput"
                @change="previewImage"
                style="display: none;"
                accept="image/*"
              />
              <div class="upload-content tw-px-4" v-if="imagePreview">
                <img
                  :src="imagePreview"
                  alt="Uploaded Image"
                  class="uploaded-image"
                  style="max-height: 168px;"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="company-block--bottom">
          <div class="tw-flex tw-justify-end tw-gap-4">
            <button class="tw-font-semibold" @click="removeLogo">Abbrechen</button>
            <button class="btn-gradient tw-font-bold" @click="createCompany">Speichern</button>
          </div>
        </div>
      </div>

      <div class="company-block">
        <div class="company-block--top">
          <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4 md:tw-gap-6 tw-py-2">
            <label class="tw-flex tw-flex-col tw-gap-2">
              <span class="tw-text-sm tw-font-medium">Unternehmen</span>

              <input
                v-model="newCompany.companyName"
                type="text"
                class="fox-input--simple tw-w-full"
              >
            </label>

            <div class="tw-hidden md:tw-block"></div>

            <label class="tw-flex tw-flex-col tw-gap-2">
              <span class="tw-text-sm tw-font-medium">Vorname</span>

              <input
                v-model="newCompany.firstName"
                type="text"
                class="fox-input--simple tw-w-full"
                v-bind:class="classes.firstName"
              >
            </label>

            <label class="tw-flex tw-flex-col tw-gap-2">
              <span class="tw-text-sm tw-font-medium">Nachname</span>

              <input
                v-model="newCompany.lastName"
                type="text"
                class="fox-input--simple tw-w-full"
                v-bind:class="classes.lastName"
              >
            </label>

            <label class="tw-flex tw-flex-col tw-gap-2">
              <span class="tw-text-sm tw-font-medium">Email</span>

              <input
                v-model="newCompany.email"
                type="email"
                class="fox-input--simple tw-w-full"
              >
            </label>

            <div class="tw-hidden md:tw-block"></div>

            <label class="tw-flex tw-flex-col tw-gap-2">
              <span class="tw-text-sm tw-font-medium">Land</span>

              <div class="tw-relative">
                <country-select
                  class="fox-input--simple fox-input--simple-select tw-w-full"
                  v-model="newCompany.country"
                  :country="newCompany.country"
                  :countryName="true"
                  placeholder="Land auswählen"
                />

                <div class="tw-absolute tw-inset-y-0 tw-right-1 tw-flex tw-items-center tw-pointer-events-none">
                  <v-icon>mdi-menu-down</v-icon>
                </div>
              </div>
            </label>

            <div class="tw-hidden md:tw-block"></div>

            <label class="tw-flex tw-flex-col tw-gap-2">
              <span class="tw-text-sm tw-font-medium">Straße & Hausnr.</span>

              <input
                v-model="newCompany.address"
                type="text"
                class="fox-input--simple tw-w-full"
                v-bind:class="classes.address"
              >
            </label>

            <div class="tw-hidden md:tw-block"></div>

            <label class="tw-flex tw-flex-col tw-gap-2">
              <span class="tw-text-sm tw-font-medium">Postleitzahl</span>

              <input
                v-model="newCompany.zipCode"
                type="text"
                class="fox-input--simple tw-w-full"
                v-bind:class="classes.zipCode"
              >
            </label>

            <label class="tw-flex tw-flex-col tw-gap-2">
              <span class="tw-text-sm tw-font-medium">Ort</span>

              <input
                v-model="newCompany.city"
                type="text"
                class="fox-input--simple tw-w-full"
                v-bind:class="classes.city"
              >
            </label>
          </div>
        </div>

        <div class="company-block--bottom">
          <div class="tw-flex tw-justify-end tw-gap-4">
            <button class="tw-font-semibold" @click="resetForm">Abbrechen</button>
            <button class="btn-gradient tw-font-bold" @click="createCompany">Speichern</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '@/services/api.service'
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

export default {
  name: 'MyCompany',
  setup: () => ({ v$: useVuelidate() }),
  data () {
    return {
      imagePreview: null,
      companyInfo: null,
      newCompany: {
        companyName: '',
        firstName: '',
        lastName: '',
        address: '',
        zipCode: '',
        city: '',
        country: '',
        email: '',
        logo: null
      }
    }
  },
  mounted () {
    this.fetchUserStatus()
    this.fetchUserCompany()
  },
  methods: {
    async fetchUserStatus () {
      try {
        await ApiService.get('/user/status')
      } catch (error) {
        this.$router.push({ name: 'Login' })
      }
    },
    async fetchUserCompany () {
      try {
        const response = await ApiService.get('/company/get')
        this.companyInfo = response.data
      } catch (error) {
        console.error('Error fetching company:', error)
      }
    },
    triggerLogoFileInput () {
      this.$refs.fileInput.click()
    },
    previewImage (event) {
      const file = event.target.files[0]
      console.log(file)
      if (file) {
        const reader = new FileReader()
        reader.onload = (e) => {
          this.imagePreview = e.target.result
        }
        reader.readAsDataURL(file)
        this.newCompany.logo = file
      }
    },
    removeLogo () {
      this.imagePreview = null
      this.newCompany.logo = null
      this.$refs.fileInput.value = null
    },
    async createCompany () {
      const isFormCorrect = await this.v$.$validate()

      if (isFormCorrect) {
        const formData = new FormData()
        formData.append('companyName', this.newCompany.companyName)
        formData.append('firstName', this.newCompany.firstName)
        formData.append('lastName', this.newCompany.lastName)
        formData.append('address', this.newCompany.address)
        formData.append('zipCode', this.newCompany.zipCode)
        formData.append('city', this.newCompany.city)
        formData.append('country', this.newCompany.country)
        formData.append('email', this.newCompany.email)
        if (this.newCompany.logo) {
          formData.append('logo', this.newCompany.logo)
        }

        await ApiService.post('/company/create', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
          .then(response => {
            console.log('Company created successfully:', response.data)
            this.resetForm()
          })
          .catch(error => {
            console.error('Error creating company:', error)
          })
      }
    },
    resetForm () {
      this.newCompany = {
        companyName: '',
        firstName: '',
        lastName: '',
        address: '',
        zipCode: '',
        city: '',
        country: '',
        email: '',
        logo: null
      }
      this.v$.$reset()
    }
  },
  validations () {
    return {
      newCompany: {
        firstName: { required },
        lastName: { required },
        address: { required },
        zipCode: { required },
        city: { required }
      }
    }
  },
  computed: {
    classes: function () {
      return {
        firstName: {
          'fox-input--error': this.v$.newCompany.firstName.$error
        },
        lastName: {
          'fox-input--error': this.v$.newCompany.lastName.$error
        },
        address: {
          'fox-input--error': this.v$.newCompany.address.$error
        },
        zipCode: {
          'fox-input--error': this.v$.newCompany.zipCode.$error
        },
        city: {
          'fox-input--error': this.v$.newCompany.city.$error
        }
      }
    }
  }
}
</script>
